// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2I2ml","col":"styles_col__3T1_c"};